<h3 mat-dialog-title>{{ 'Card Content Customization' | translate }}</h3>

<mat-dialog-content class="designer">
    <div class="stage">
        @if (previewRegister) {
            <div class="stage-card">
                <app-risk-register-matrix-cell
                    [register]="previewRegister"
                    [profile]="data.profile"
                    [designMode]="true"
                    [designSlots]="data.editableSlots"
                    [highlightSlot]="activeSlot"
                    [hoverSlot]="hoverSlot"
                    (slotPick)="selectSlot($event)"
                    (slotHover)="hover($event)"></app-risk-register-matrix-cell>
            </div>
        } @else {
            <p class="stage-empty">{{ 'No risk registers to preview' | translate }}</p>
        }
        <p class="stage-hint">{{ 'Click a part of the card, then choose what it shows' | translate }}</p>
    </div>

    <div class="controls">
        <section class="control-section">
            <h4 class="section-title">{{ 'Card spots' | translate }}</h4>
            <div class="slot-list">
                @for (row of rows; track row.key) {
                    <button type="button" class="slot-row" [class.active]="row.key === activeSlot"
                        [class.hovered]="row.key === hoverSlot" (click)="selectSlot(row.key)"
                        (mouseenter)="hover(row.key)" (mouseleave)="hover(null)">
                        <span class="slot-name">{{ row.label | translate }}</span>
                        <span class="slot-value">{{ row.optionLabel | translate }}</span>
                    </button>
                }
            </div>
        </section>
        <section class="control-section options-section">
            <h4 class="section-title">{{ optionsTitleKey | translate: { slot: (slotLabels[activeSlot] | translate) } }}</h4>
            <div class="option-grid">
                @for (option of options; track option.value) {
                    <button type="button" class="option-chip" [class.selected]="draft[activeSlot] === option.value"
                        (mouseenter)="previewOption(option.value)" (mouseleave)="previewOption(null)"
                        (click)="select(option.value)">{{ option.label | translate }}</button>
                }
            </div>
        </section>
    </div>
</mat-dialog-content>

<mat-dialog-actions class="designer-actions">
    <button type="button" class="btn action-btn action-text reset-btn" (click)="reset()">
        <span class="material-symbols-outlined action-icon">restart_alt</span>
        {{ 'Reset to Defaults' | translate }}
    </button>
    <div class="action-group">
        <button type="button" class="btn action-btn action-text" mat-dialog-close>{{ 'Cancel' | translate }}</button>
        <button type="button" class="btn action-btn action-outline" (click)="apply(true)">
            <span class="material-symbols-outlined action-icon">bookmark_add</span>
            {{ 'Save as View' | translate }}
        </button>
        <button type="button" class="btn action-btn action-primary" (click)="apply()">{{ 'Apply' | translate }}</button>
    </div>
</mat-dialog-actions>
